module.exports = __webpack_public_path__ + "img/windy_strong.1df9a37f.svg";